import { observer } from 'mobx-react';
import React from 'react';
import InstructionAudioList from './InstructionAudioList';
import InstructionAudioListService from '../services/InstructionAudioListService';
import { toJS } from 'mobx';

class InstructionAudioListContainer extends React.Component {
  componentDidMount() {
    InstructionAudioListService.handleLoad();
  }

  render() {
    return (
      <InstructionAudioList
        onDelete={InstructionAudioListService.handleRemove}
        items={toJS(InstructionAudioListService.items)}
        loading={InstructionAudioListService.fetch.fetching}
        pagination={InstructionAudioListService.pagination}
      />
    );
  }
}

export default observer(InstructionAudioListContainer);
